export default "__VITE_ASSET__vEyZW7oE__"